const isNonEmptyString = (value) =>
  typeof value === "string" && value.trim().length > 0;

const getValueByPath = (obj, path) => {
  return path.split(".").reduce((acc, part) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
      return acc[part];
    }
    return undefined;
  }, obj);
};

const findFirstMessage = (sources, paths) => {
  for (const source of sources) {
    if (!source) {
      continue;
    }

    if (isNonEmptyString(source)) {
      return source.trim();
    }

    for (const path of paths) {
      const value = getValueByPath(source, path);
      if (isNonEmptyString(value)) {
        return value.trim();
      }
    }

    if (Array.isArray(source.errors)) {
      const [firstError] = source.errors;

      if (isNonEmptyString(firstError)) {
        return firstError.trim();
      }

      if (firstError && typeof firstError === "object") {
        const nestedError = findFirstMessage([firstError], paths);
        if (nestedError) {
          return nestedError;
        }
      }
    }
  }

  return "";
};

export default function getBackendErrorMessage(
  error,
  fallback = "Error processing order",
) {
  const responseData = error?.response?.data;
  const topLevelData = error?.data;

  // Prioritize backend payload first; Axios top-level error.message is usually generic.
  const sources = [responseData, topLevelData, error];

  const primaryMessage = findFirstMessage(sources, [
    "message",
    "msg",
    "error",
    "error.message",
    "error.raw.message",
    "error.detail",
    "error_description",
    "details.message",
    "data.message",
  ]);

  if (isNonEmptyString(primaryMessage)) {
    return primaryMessage;
  }

  return fallback;
}
